export const brandBgSid = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
